import { graphql } from '@/generated/gql';

export const NEGOTIATION_CASE_RESET_MUTATION = graphql(/* GraphQL */ `
  mutation NegotiationCaseReset($id: UUID!) {
    tesseract {
      negotiationCase(id: $id) {
        reset
      }
    }
  }
`);
